const Logo = "/assets/images/logo.svg";
const Loader = "/assets/images/Loader.gif";
const TickAlert = "/assets/images/tick-alert.svg";
const ErrorAlert = "/assets/images/error-alert.svg";
const Tick = "/assets/images/tick.svg";
const DefaultOrganization = "/assets/images/default-organisation.jpg";
const DefaultPortal = "/assets/images/default-portal.jpg";
const BackgroundImage = "/assets/images/background.svg";


export const IMAGES = {
  Logo,
  Loader,
  TickAlert,
  ErrorAlert,
  Tick,
  DefaultOrganization,
  DefaultPortal,
  BackgroundImage
};
